import { PayloadAction } from '@reduxjs/toolkit';
import { History } from 'history';
import { NormalizedSchema } from 'normalizr';
import { TakeableChannel } from 'redux-saga';

export interface StoreActionProps<P> {
  type: TakeableChannel<unknown> | string;
  payload: P;
}

export type NormalizedData<T> = Record<number, T>;

export enum FetchStatus {
  None = 'none',
  Loading = 'loading',
  Loaded = 'loaded',
  Partial = 'partial',
  Error = 'error',
}

export type ItemsFetchStatus = NormalizedData<FetchStatus>;

export type SavePayloadAction<T> = PayloadAction<{
  data: T;
  fetchStatus: FetchStatus;
}>;

export interface EntityState<T> {
  items: NormalizedData<T>;
  itemsFetchStatus: ItemsFetchStatus;
  isLoading: boolean;
  isError: boolean;
}

export interface ItemFetchStatusResult {
  isLoading: boolean;
  isError: boolean;
  isPartial: boolean;
  isSuccess: boolean;
  status: FetchStatus;
}

export interface QueryResult<T> extends ItemFetchStatusResult {
  data: T;
}

export enum SchemaKeys {
  Home = 'home',
  Projects = 'projects',
  Tasks = 'tasks',
  SpaceTabs = 'spaceTabs',
  Spaces = 'spaces',
}

export type Result = number[];
export type NormalizedResult<E> = NormalizedSchema<E, Result>;

export interface HistoryPayload<T> {
  data: T;
  history: History;
}
